(() => {
  'use strict';
  if (window.DPSAccountUI) return;
  window.DPSAccountUI = true;
  const config = document.querySelector('[data-account-menu]');
  const english = config?.dataset.language === 'en';
  const text = (es, en) => english ? en : es;
  const endpoint = 'https://djpoolstore-club.inthemixstyle.workers.dev/profile';
  let session, avatar, loaded = false, pending;
  const status = message => { const el=document.querySelector('[data-avatar-status]'); if(el) el.textContent=message; };
  async function auth() {
    if (session && Date.parse(session.expires_at) > Date.now() + 60000) return session;
    const response=await fetch(config.dataset.sessionPath,{credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}});
    if(!response.ok) throw new Error('sign_in_required');
    session=await response.json();
    if(String(session.customer_id).split('/').pop() !== config.dataset.customer || !session.token?.startsWith('chrm_st_')) { session=null; throw new Error('sign_in_required'); }
    return session;
  }
  async function call(action, image, retry=true) {
    const key=await auth();
    const response=await fetch(endpoint,{method:'POST',headers:{Authorization:`Bearer ${key.token}`,'Content-Type':'application/json'},body:JSON.stringify({customer:config.dataset.customer,action,image}),cache:'no-store'});
    const data=await response.json();
    if(response.status===429 && data.error==='try_again_shortly' && retry){await new Promise(resolve=>setTimeout(resolve,1800));return call(action,image,false);}
    if(!response.ok) { if(response.status===401)session=null; throw new Error(data.error || 'unavailable'); }
    return data;
  }
  function paint() {
    document.querySelectorAll('[data-account-avatar]').forEach(node=>{
      const img=node.querySelector('img');
      const valid=avatar?.mime==='image/jpeg' && /^[A-Za-z0-9+/]+={0,2}$/.test(avatar.image||'') && avatar.image.length<=120000;
      img.hidden=!valid;
      if(valid) img.src=`data:image/jpeg;base64,${avatar.image}`; else img.removeAttribute('src');
    });
    const remove=document.querySelector('[data-avatar-remove]');if(remove)remove.hidden=!avatar;
  }
  async function refresh() {
    document.querySelectorAll('[data-account-menu][open]').forEach(menu=>menu.open=false);
    if(!config?.dataset.customer) return;
    if(loaded){paint();return;}
    if(pending)return pending;
    pending=(async()=>{try{const data=await call('get');avatar=data.avatar;loaded=true;paint();}catch{status(text('La foto no está disponible ahora. Inténtalo de nuevo.','Your photo is unavailable right now. Please try again.'));}finally{pending=null;}})();
    return pending;
  }
  async function imageBase64(file) {
    if(!['image/jpeg','image/png','image/webp'].includes(file.type)||file.size>5*1024*1024)throw new Error('invalid_file');
    const bitmap=await createImageBitmap(file);
    try {
      const canvas=document.createElement('canvas');canvas.width=canvas.height=384;
      const ctx=canvas.getContext('2d');ctx.fillStyle='#1a211b';ctx.fillRect(0,0,384,384);
      const side=Math.min(bitmap.width,bitmap.height);
      ctx.drawImage(bitmap,(bitmap.width-side)/2,(bitmap.height-side)/2,side,side,0,0,384,384);
      for(const quality of [.84,.72,.6,.45]){const encoded=canvas.toDataURL('image/jpeg',quality).split(',')[1];if(encoded.length<=120000)return encoded;}
      throw new Error('invalid_file');
    } finally {bitmap.close();}
  }
  document.addEventListener('change',async event=>{
    if(!event.target.matches('[data-avatar-input]'))return;
    const input=event.target,file=input.files?.[0];if(!file)return;
    input.disabled=true;status(text('Guardando tu foto…','Saving your photo…'));
    try{
      const image=await imageBase64(file),data=await call('set',image);avatar=data.avatar;loaded=true;paint();
      status(text('Foto guardada en tu cuenta.','Photo saved to your account.'));
    }catch(error){status(error.message==='invalid_file'?text('Elige una imagen JPG, PNG o WebP de hasta 5 MB.','Choose a JPG, PNG or WebP image up to 5 MB.'):text('No pudimos guardar la foto. Vuelve a intentarlo.','We could not save your photo. Please try again.'));}
    finally{input.disabled=false;input.value='';}
  });
  document.addEventListener('click',async event=>{
    if(event.target.closest('[data-avatar-choose]')){document.querySelector('[data-avatar-input]')?.click();return;}
    const menu=document.querySelector('[data-account-menu]');
    if(menu && !menu.contains(event.target)) menu.open=false;
    const remove=event.target.closest('[data-avatar-remove]');if(!remove)return;
    remove.disabled=true;status(text('Quitando foto…','Removing photo…'));
    try{await call('remove');avatar=null;paint();status(text('Foto eliminada.','Photo removed.'));}
    catch{status(text('No pudimos quitar la foto. Inténtalo de nuevo.','We could not remove your photo. Please try again.'));}
    finally{remove.disabled=false;}
  });
  document.addEventListener('keydown',event=>{if(event.key==='Escape'){const menu=document.querySelector('[data-account-menu]');if(menu?.open){menu.open=false;menu.querySelector('summary').focus();}}});
  document.addEventListener('dps:page-loaded',refresh);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',refresh);else refresh();
})();
